import { useHooks } from "./hooks";

export const TakashioPlugin = ({ on }: { on: boolean }) => {
  const { map } = useHooks(on);

  if (map) {
    return <></>;
  }

  return null;
};
